<template>
  <div>
    <div class="barline-title">Análisis de Precio</div>
    <div class="barline-subtitle">
      <strong>Precio de Referencia:</strong> precio de mercado posición cosecha.<br>
      <strong>Precio Dolor:</strong> precio necesario para obtener 20% de renta.<br>
        <strong>Precio de indiferencia:</strong> precio necesario para cubrir el total de los costos, conforme el rinde presupuestado.</div>
    <v-chart id="bar-line-scatter" :options="graph"/>
  </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'bar-line-scatter',
  components: {'v-chart': ECharts},
  props: ['data','regions'],

  data() {
    return {
      graph: {
        grid: {
          top: 100,
          height: 250,
          left:'15%',
          bottom: 110
        },
        tooltip: {
          show: true
        },
        xAxis: {
          type: 'category',
          data: this.regions,
          nameRotate: 90,
          axisLabel : {
            rotate: 90
          }

        },
        legend: {
          show: true,
          data: ['Precio de referencia', 'Precio Dolor', 'Precio de Equilibrio'],
          top: 30,
          itemGap: 50,
          textStyle: {
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: 'USD/t',
          nameTextStyle: {
            fontSize: 14,
            color: '#3c4858',
            align: 'left'
          },
          min: function(element) {
            return Math.round(element.min - (element.min * 0.05));
          },
          max: function(element) {
            return Math.ceil(element.max + (element.max * 0.05));
          },
          axisLabel: {
            //formatter: '{value} USD/t'
            formatter: '{value}'
          },
          splitLine: {
            show: false
          },
          offset:15

        },
        textStyle: {
          fontFamily: 'Gotham-Book, Arial',
          color: '#888'
        },
        series: [
          {
            name: 'Precio de referencia',
            data: this.data.ref,
            type: 'line',
            color:'#888',
            symbolSize: 5,
            lineStyle: {
              width: 5
            }
          },
          {
            name: 'Precio Dolor',
            symbolSize: 20,
            data: this.data.dolor,
            type: 'scatter',
            color:'#249DA5'
          },
          {
            name: 'Precio de Equilibrio',
            data: this.data.indif,
            type: 'bar',
            color: '#0961AF',
            barMaxWidth: 40,
            itemStyle: {
              barBorderRadius: [4,4,0,0]
            }
          }
        ]

      },
    }
  },

  methods: {
    changeLegendInMobileView() {
      this.graph.legend.textStyle.fontSize = 12;
      this.graph.legend.itemGap = 5;
      this.graph.legend.orient = 'vertical';
    },
    changeDotsSizeInMobileView() {
      this.graph.series[1].symbolSize = 10
    },
    changeBarsWidthInMobileView() {
      this.graph.series[2].barMaxWidth = 15
    },
    modifyChartInMobileView() {
      if (window.screen.width < 600) {
        this.changeLegendInMobileView();
        this.changeDotsSizeInMobileView();
        this.changeBarsWidthInMobileView();
      }
    },
  },

  mounted() {
    this.modifyChartInMobileView()
  }


}
</script>
<style>
    #bar-line-scatter{
        height: 550px;
    }
    .barline-title{
      font-family: Gotham-Book;
      font-size: 18px;
      color: '#5E5E5E';
      margin-bottom: 10px;
    }
    .barline-subtitle{
      font-family: Gotham-Book;
      font-size: 14px;
      line-height: 1.3em;
      color: '#777';
    }
    @media only screen and (max-width: 600px) {
      .barline-subtitle{
        font-size: 12px;
      }
    }
</style>
